import React from 'react';
import { HeaderStyled, SectionTitleStyled } from './styles';
import { OVERRIDE_RATES_SECTION_HEADER_TEST_ID } from '../constants';

interface Props {
  title: string;
  actionSection?: React.ReactNode;
  className?: string;
}

export const SectionHeader: React.FC<Props> = ({ title, actionSection, className }) => {
  return (
    <HeaderStyled className={className} data-test-id={OVERRIDE_RATES_SECTION_HEADER_TEST_ID}>
      <SectionTitleStyled>{title}</SectionTitleStyled>
      {actionSection}
    </HeaderStyled>
  );
};
